import React from "react";
import "./ContactPage.css";
import emailjs from "@emailjs/browser";
import HeaderPD from "../components/Parts/HeaderPD.jsx";
import Footer from "../components/Parts/Footer.jsx";

const ContactPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();

    const btn = document.getElementById("submit-btn");
    btn.value = "Sending...";

    const serviceID = "service_ayexp79"; // Replace with your EmailJS Service ID
    const templateID = "template_eo7zpsa"; // Replace with your EmailJS Template ID

    emailjs
      .sendForm(serviceID, templateID, e.target, "2oi6mLltyb3sKM7xe") // Replace with your EmailJS Public Key
      .then(
        () => {
          btn.value = "Submit";
          alert("Email Sent Successfully!");
          e.target.reset();
        },
        (err) => {
          btn.value = "Submit";
          alert(JSON.stringify(err));
        }
      );
  };

  return (
    <>
      <HeaderPD />
      <div className="contact-container">
        <div className="contact-info">
          <h1>Contact Us</h1>
          <p>
            Email, call, or complete the form to share your property details
            with us.
          </p>
          <p>Email: rinesagllareva@gmail.com</p>
          <p>Phone: +383-49-262-282</p>
          <a href="/support">Customer Support</a>
          <div className="support-columns">
            <div>
              <h3>Customer Support</h3>
              <p>
                Ne jemi në dispozicion gjatë gjithë kohës për të adresuar çdo
                shqetësim që mund të keni.
              </p>
            </div>
            <div>
              <h3>Feedback and Suggestions</h3>
              <p>
                Komentet tuaja janë të vlefshme për të na ndihmuar të
                përmirësojmë shërbimet tona.
              </p>
            </div>
            <div>
              <h3>Media Inquiries</h3>
              <p>
                Për pyetje në lidhje me median, ju lutemi na kontaktoni në
                rinesagllareva@gmail.com.
              </p>
            </div>
          </div>
        </div>
        <div className="contact-form">
          <h2>Get in Touch</h2>
          <p>Mund të na kontaktoni në çdo kohë</p>
          <form id="form" onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="name"> Name</label>
              <input type="text" id="name" name="name" required />
            </div>
            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="form-field">
              <label htmlFor="phone">Phone</label>
              <input type="tel" id="phone" name="phone" required />
            </div>
            <div className="form-field">
              <label for="description">description</label>
              <input type="text" name="description" id="description"></input>
            </div>
            <button id="submit-btn" type="submit">
              Submit
            </button>
          </form>
          <p className="form-terms">
            By contacting us, you agree to our{" "}
            <a href="/terms">Terms of Service</a> and{" "}
            <a href="/privacy">Privacy Policy</a>.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
